export function Admin() {
  return (
    <div style={{ padding: '2rem', fontFamily: 'system-ui, sans-serif' }}>
      <h1>Admin panel</h1>
      <p>Em construção — plano P-admin futuro.</p>
    </div>
  );
}
